export default __webpack_public_path__ + "static/media/olivia_rodrigo.e3cdf693.svg";